module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/productos/producto.component.scss
// module id = ./src/app/productos/producto.component.scss
// module chunks = main